import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ImageAndContent from 'components/consumer/ImageAndContent';
const ImageContentBlock = t0 => {
  const $ = _c(14);
  const {
    blockConfig,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const t2 = blockConfig?.imageUrl;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      imageUrl: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = blockConfig?.textSection?.textColor;
  const t5 = blockConfig?.textSection?.textOrientation;
  const t6 = blockConfig?.title;
  const t7 = blockConfig?.body;
  let t8;
  if ($[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7) {
    t8 = {
      textColor: t4,
      textOrientation: t5,
      title: t6,
      body: t7
    };
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = blockConfig?.buttonSection;
  let t10;
  if ($[7] !== t3 || $[8] !== t8 || $[9] !== t9) {
    t10 = {
      componentSelection: t3,
      textContentSection: t8,
      buttonSection: t9
    };
    $[7] = t3;
    $[8] = t8;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isMobile || $[12] !== t10) {
    t11 = <ImageAndContent config={t10} columnMode={true} isMobile={isMobile} />;
    $[11] = isMobile;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};
export default ImageContentBlock;